import React from 'react'
import Navbar from '../components/Navbar'
import '../pages/about.css'

function About() {
  return (
    <>
      <Navbar/>
      <div name='about' className='about-container'>
        
        <section class="about-us">
          <div class="about">
            <img src="https://cdn.harekrishnabooks.com/2019/05/Bhagavad-Gita-Hindi-1.jpg" class="img-thumbnail pic" alt="..."></img>
            <div class="text">
            <h2>श्रीमद भगवत गीता</h2>
              <hr></hr>
                    <p>श्रीमद्भगवद्‌गीता हिन्दुओं के पवित्रतम ग्रन्थों में से एक है। महाभारत के अनुसार कुरुक्षेत्र युद्ध में भगवान श्री कृष्ण ने गीता का सन्देश अर्जुन को सुनाया था। यह महाभारत के भीष्मपर्व के अन्तर्गत दिया गया एक उपनिषद् है। भगवत गीता में एकेश्वरवाद, कर्म योग, ज्ञानयोग, भक्ति योग की बहुत सुन्दर ढंग से चर्चा हुई है।श्रीमद्भगवद्‌गीता की पृष्ठभूमि महाभारत का युद्ध है। जिस प्रकार एक सामान्य मनुष्य अपने जीवन की समस्याओं में उलझकर किंकर्तव्यविमूढ़ हो जाता है और जीवन की समस्यायों से लड़ने की बजाय उससे भागने का मन बना लेता है उसी प्रकार अर्जुन जो महाभारत के महानायक थे, अपने सामने आने वाली समस्याओं से भयभीत होकर जीवन और क्षत्रिय धर्म से निराश हो गए थे, अर्जुन की तरह ही हम सभी कभी-कभी अनिश्चय की स्थिति में या तो हताश हो जाते हैं और या फिर अपनी समस्याओं से विचलित होकर भाग खड़े होते हैं। <br/>
                    इसीलिए भगवान श्रीकृष्ण ने जन सामान्य के लिए कर्तव्यनिष्ठ मार्ग को इंगित करने के लिए इस महाज्ञान को गीता के माध्यम से प्रस्तुत किया है। हम सभी 18 अध्याय, आपके लिए संस्कृत श्लोकों के सरल हिंदी अनुवाद के साथ आपके लिए प्रकाशित कर रहे हैं, ताकि आप इसे आसानी से पढ़ सके। </p>
              <hr></hr>
            </div>
          </div>
        </section>
        
      </div>
    </>
    
  )
}

export default About